import { Directive, input } from '@angular/core';
import { AbstractControl } from '@angular/forms';

const BASE =
  'block w-full min-h-11 rounded-md bg-surface px-3 py-2 text-base text-fg ' +
  'outline-1 -outline-offset-1 placeholder:text-fg-subtle ' +
  'focus:outline-2 focus:-outline-offset-2 sm:text-sm/6';

/**
 * text-base on mobile, sm:text-sm/6 above: 16px stops iOS Safari zooming the page on
 * focus. Keep both halves.
 *
 * `bg-surface` makes the field darker than the card it sits in, reading as a recess
 * rather than another raised panel, and it is what lifts the placeholder to 4.98:1.
 * `min-h-11` is 44px, matching the buttons, so a field and its submit are the same
 * touch size.
 */
@Directive({
  selector: 'input[appInput], textarea[appInput], select[appInput]',
  host: { '[class]': 'classes()', '[attr.aria-invalid]': 'invalid() || null' },
})
export class InputDirective {
  /** Drives the error styling; pass the reactive control that owns this field. */
  readonly control = input<AbstractControl | null>(null);

  /** Methods, not computeds: a form control's identity never changes, so a computed
   *  reading `control()` caches its first answer and the outline never turns red. */
  protected invalid(): boolean {
    const c = this.control();
    return !!c && c.invalid && c.touched;
  }

  protected classes(): string {
    return this.invalid()
      ? `${BASE} outline-danger focus:outline-danger text-danger-fg`
      : `${BASE} outline-border-strong focus:outline-brand`;
  }
}
